<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Dashboard</div>
		</div>
		<div class="mt-5" v-if="loading">
			<div v-for="i in 2" :key="i">
				<v-card height="15" width="240" elevation="0" class="mb-2">
					<vcl :height='15' :width='240'>
						<rect x="0" y="0" rx="2" ry="2" width="240" height="15" />
					</vcl>
				</v-card>
				<div class="row ml-0">
					<v-col cols="2" class="pl-0" v-for="i in 6" :key="i">
						<v-card height="85" width="180">
							<vcl :height='85' :width='180'>
								<rect x="15" y="15" rx="8" ry="8" width="25" height="25" />
								<rect x="140" y="15" rx="8" ry="8" width="25" height="25" />
								<rect x="70" y="60" rx="4" ry="4" width="95" height="20" />
							</vcl>
						</v-card>
					</v-col>
				</div>
				<div class="row ml-0">
					<div class="col-6 pl-0" v-for="i in 2" :key="i">
						<v-card height="260" width="550">
							<vcl :height='260' :width='550'>
								<rect x="15" y="15" rx="4" ry="4" width="120" height="15" />
								<rect x="15" y="50" rx="4" ry="4" width="450" height="190" />
							</vcl>
						</v-card>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!loading">
			<div>
				<div class="mt-5">
					<v-btn text small color="grey darken-3" class="">
						<div class="pr-2">Resume Aktivitas Penjualan</div>
						<v-icon>mdi-chevron-right</v-icon>
					</v-btn>
				</div>
				<v-card color="white" class="my-2" height="100" width="350" v-if="listSalesActivity.length == 0">
					<not-found-cyan></not-found-cyan>
				</v-card>
				<div v-if="renderChart">
					<div v-if="listSalesActivity.length > 0">
						<carousel :loop="false" :responsive="{0:{items:2},600:{items:4},1000:{items:6},1500:{items:8}}" :nav="false" :dots="false" :margin="5">
							<div v-for="(salesActivity, i) in listSalesActivity" :key="i" class="pt-2 pb-3 px-1">
								<v-card class="text-body-2" height="100" width="180">
									<v-col cols="12" class="pt-3 pb-1 d-flex justify-space-between mt-2">
										<div>
											<v-icon color="teal lighten-3" v-if="salesActivity.po_status == 'created' || salesActivity.po_status == 'wh_approved'">mdi-circle-slice-5</v-icon>
											<v-icon color="pink lighten-3" v-else-if="salesActivity.po_status == 'supp_rejected' || salesActivity.po_status == 'wh_rejected'">mdi-close-circle</v-icon>
											<v-icon color="teal lighten-3" v-else-if="salesActivity.po_status == 'supp_processed'">mdi-arrow-up-bold-circle</v-icon>
											<v-icon color="teal lighten-3" v-else>mdi-check-circle</v-icon>
										</div>
										<div class="text-right my-auto grey--text text--darken-3">
											<div class="text-h5">{{ salesActivity.count_status | toNumber }}</div>
										</div>
									</v-col>
									<div class="px-3 text-right">
										<div class="text-caption">{{ salesActivity.po_status | toStatusPOWH }}</div>
									</div>
								</v-card>
							</div>
						</carousel>
					</div>
				</div>
			</div>
			<div>
				<v-row class="mr-0" v-if="renderChart">
					<v-col cols="12" md="12" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Penjualan</div>
							</div>
							<sschart />
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div>
				<div class="mt-5">
					<v-btn text small color="grey darken-3" class="">
						<div class="pr-2">Resume Aktivitas Retur</div>
						<v-icon>mdi-chevron-right</v-icon>
					</v-btn>
				</div>
				<v-card color="white" class="my-2" height="100" width="350" v-if="listReturnActivity.length == 0">
					<not-found-cyan></not-found-cyan>
				</v-card>
				<div v-if="renderChart">
					<div v-if="listReturnActivity.length > 0">
						<carousel :loop="false" :responsive="{0:{items:2},600:{items:4},1000:{items:6},1500:{items:8}}" :nav="false" :dots="false" :margin="5">
							<div v-for="(returnActivity, i) in listReturnActivity" :key="i" class="pt-2 pb-3 px-1">
								<v-card class="text-body-2" height="85" width="180">
									<v-col cols="12" class="pt-3 pb-1 d-flex justify-space-between mt-2">
										<div>
											<v-icon color="teal lighten-3" v-if="returnActivity.por_status == 'processed'">mdi-arrow-up-bold-circle</v-icon>
											<v-icon color="pink lighten-3" v-else-if="returnActivity.por_status == 'rejected'">mdi-close-circle</v-icon>
											<v-icon color="teal lighten-3" v-else>mdi-check-circle</v-icon>
										</div>
										<div class="text-right my-auto grey--text text--darken-3">
											<div class="text-h5">{{ returnActivity.count_status | toNumber }}</div>
										</div>
									</v-col>
									<div class="px-3 text-right">
										<div class="text-caption">{{ returnActivity.por_status | toStatusReturn }}</div>
									</div>
								</v-card>
							</div>
						</carousel>
					</div>
				</div>
			</div>
			<div>
				<v-row class="mr-0" v-if="renderChart">
					<v-col cols="12" md="8" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Produk Terjual</div>
							</div>
							<salesChart />
						</v-card>
					</v-col>
					<v-col cols="12" md="4" class="pr-0">
						<v-card class="pt-2">
							<div class="px-4 d-flex justify-space-between">
								<div class="text-overline grey--text text--darken-3 text-uppercase">Resume Top 5 Warehouse</div>
							</div>
							<div class="pb-2" v-if="listTopWarehouse.length == 0">
								<not-found-cyan></not-found-cyan>
							</div>
							<div v-else>
								<v-list-item class="border-bottom border-grey py-1" v-for="(topWarehouse, i) in listTopWarehouse" :key="i">
									<v-chip class="white--text font-weight-bold" color="cyan darken-2">{{ topWarehouse.rank }}</v-chip>
									<div class="ml-3">
										<v-img width="70" src="/assets/icon/avatar-warehouse.png"></v-img>
									</div>
									<v-list-item-content class="ml-4">
										<v-list-item-title class="grey--text text--darken-3">{{ topWarehouse.warehouse_name }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div>
				<div class="mt-5">
					<v-btn text small color="grey darken-3" class="">
						<div class="pr-2">Resume Penjadwalan PO + Retur</div>
						<v-icon>mdi-chevron-right</v-icon>
					</v-btn>
				</div>
				<div>
					<v-row>
						<v-col>
							<v-btn width="180" large class="elevation-2" :color="notProcess == true ? 'cyan lighten-5' : 'white'" @click="showNotProcess">
								<img src="/assets/icon/belum-proses.svg">
								<div class="pl-3 text-caption cyan--text text--darken-2">Belum Diproses ({{listScheduleWaiting.length}})</div>
							</v-btn>
							<v-btn width="180" large class="ml-4 elevation-2" :color="today == true ? 'cyan lighten-5' : 'white'" @click="showToday">
								<img src="/assets/icon/hari-ini.svg">
								<div class="pl-3 text-caption cyan--text text--darken-2">Hari Ini ({{listScheduleToday.length}})</div>
							</v-btn>
							<v-btn width="180" large class="ml-4 elevation-2" :color="tomorrow == true ? 'cyan lighten-5' : 'white'" @click="showTomorrow">
								<img src="/assets/icon/besok.svg">
								<div class="pl-3 text-caption cyan--text text--darken-2">Besok ({{listScheduleTomorrow.length}})</div>
							</v-btn>
						</v-col>
					</v-row>
				</div>
				<div class="py-3">
					<v-card outlined v-if="notProcess">
						<v-data-table :headers="headers" :items="listScheduleWaiting" class="white-row">
							<template v-slot:item.po_schedule_detail_date="{ item }">
								{{ item.po_schedule_detail_date | tanggal }}
							</template>
						</v-data-table>
					</v-card>
					<v-card outlined v-else-if="today">
						<v-data-table :headers="headers" :items="listScheduleToday" class="white-row">
							<template v-slot:item.po_schedule_detail_date="{ item }">
								{{ item.po_schedule_detail_date | tanggal }}
							</template>
						</v-data-table>
					</v-card>
					<v-card outlined v-else>
						<v-data-table :headers="headers" :items="listScheduleTomorrow" class="white-row">
							<template v-slot:item.po_schedule_detail_date="{ item }">
								{{ item.po_schedule_detail_date | tanggal }}
							</template>
						</v-data-table>
					</v-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import sschart from './salesSummaryChart'
import salesChart from './productSummaryChart'
import carousel from 'vue-owl-carousel'
import { mapActions,  mapState } from 'vuex'

export default {
	inject: ['theme'],
	components: {
		sschart, salesChart, carousel
	},
	data() {
		return {
			model: null,
			renderChart: false,
			notProcess: true,
			today: false,
			tomorrow: false,
			loading: true,
			headers: [
			{ text: 'Nama Warehouse', align: 'start', value: 'warehouse_name', sortable: true},
			{ text: 'Kode Transaksi', value: 'po_code', sortable: false},
			{ text: 'Produk', value: 'supplier_product_name', sortable: false},
			{ text: 'Quantity', value: 'po_schedule_detail_quantity', sortable: false, align: 'center'},
			{ text: 'Tanggal Pengiriman', value: 'po_schedule_detail_date', sortable: true},
			],
		}
	},
	computed: {
		...mapState('dashboardSupplier', ['listSalesActivity', 'listTopWarehouse', 'listReturnActivity', 'listScheduleWaiting', 'listScheduleToday', 'listScheduleTomorrow']),
	},
	methods: {
		...mapActions('dashboardSupplier', ['getSalesActivity', 'getTopWarehouse', 'getReturnActivity', 'getScheduleWaiting', 'getScheduleToday', 'getScheduleTomorrow']),

		getData() {
			this.getSalesActivity().then(() => {
				this.getTopWarehouse().then(() => {
					this.getReturnActivity().then(() => {
						this.getScheduleWaiting().then(() => {
							this.getScheduleToday().then(() => {
								this.getScheduleTomorrow().then(() => {
									this.loading = false
								})
							})
						})
					})
				})
			})
		setTimeout(() => {this.renderChart = true}, 500);
		},
		showNotProcess() {
			this.notProcess = true
			this.today = false
			this.tomorrow = false
		},
		showToday() {
			this.notProcess = false
			this.today = true
			this.tomorrow = false
		},
		showTomorrow() {
			this.notProcess = false
			this.today = false
			this.tomorrow = true
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Dashboard`)
		this.getData()
	}
};
</script>